module.exports = __webpack_public_path__ + "img/xlph2.077c39a9.jpg";